import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
    selector: 'app-continue-button',
    templateUrl: './continue-button.component.html',
    styleUrls: ['./continue-button.component.scss'],
    standalone: false
})
export class ContinueButtonComponent implements OnInit {
  @Input() label: string;
  @Input() route = '';
  // TODO:#code
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter();

  constructor(
    private navigation: StudyNavigationService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm('INSTRUCTION_CONTINUE_BUTTON');
    }
  }

  navigateToNext() {
    this.onClick.emit();
    this.navigation.renderNext();
  }
}
